"use strict";

var _defineProperty = require("C:\\Users\\Charly\\Documents\\TGC\\Contacta-Abogado\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _objectSpread = require("C:\\Users\\Charly\\Documents\\TGC\\Contacta-Abogado\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _mediaEngine = _interopRequireDefault(require("media-engine"));
/**
 * Resolves media queries in styles object
 *
 * @param {Object} container
 * @param {Object} styles object
 */


var resolveMediaQueries = function resolveMediaQueries(container, styles) {
  return Object.keys(styles).reduce(function (acc, key) {
    if (/@media/.test(key)) {
      return _objectSpread(_objectSpread({}, acc), (0, _mediaEngine.default)(_defineProperty({}, key, styles[key]), container));
    }

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, styles[key]));
  }, {});
};

var _default = R.curryN(2, resolveMediaQueries);

exports.default = _default;